import { api } from '../../api/client';
import type { RegistrationRole } from '../registration/model';

export type VkOAuthFlow = 'login' | 'registration' | 'request';

export interface PendingVkRegistration {
  email: string;
  email_required: boolean;
  first_name: string;
  last_name: string;
  display_name: string;
  role: RegistrationRole;
  flow: VkOAuthFlow;
}

export function startVkOAuth(role: RegistrationRole, flow: VkOAuthFlow): void {
  const params = new URLSearchParams({ role, flow });
  window.location.assign(`/api/auth/vk/start/?${params.toString()}`);
}

export function loadPendingVkRegistration(): Promise<PendingVkRegistration> {
  return api<PendingVkRegistration>('/api/auth/vk/pending/');
}

export function vkOAuthErrorMessage(code: string | null): string {
  if (!code) return '';
  if (code === 'access_denied') return 'Вы отменили вход через VK ID.';
  if (code === 'email_exists') return 'Аккаунт с этой почтой уже есть. Войдите по паролю, чтобы безопасно привязать VK ID.';
  if (code === 'profile_incomplete') return 'VK ID не передал идентификатор профиля. Попробуйте ещё раз.';
  if (code === 'role_missing') return 'В аккаунте нет выбранного профиля заказчика или перевозчика.';
  if (code === 'not_configured') return 'Вход через VK ID пока не настроен.';
  if (code === 'invalid_state' || code === 'expired') return 'Сессия входа через VK ID устарела. Попробуйте ещё раз.';
  return 'Не удалось войти через VK ID. Попробуйте ещё раз.';
}
